import { render, staticRenderFns } from "./warehouseUser.vue?vue&type=template&id=60cb07df&"
import script from "./warehouseUser.vue?vue&type=script&lang=js&"
export * from "./warehouseUser.vue?vue&type=script&lang=js&"
import style0 from "./warehouseUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports